import { OnRequestChangeCallback } from 'services/APIs/BaseAPI'
import {
  ProjectSupplierDto,
  WorkingStepType,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'

export interface IProjectSuppliersAPI {
  getSuppliers: (
    workingStepTypeFilter?: WorkingStepType[] | null,
  ) => Promise<ProjectSupplierDto[]>
}

export class ProjectSuppliersAPI
  extends InternalAPI
  implements IProjectSuppliersAPI
{
  constructor(
    partyId: string,
    projectId: string,
    onRequestChanged?: OnRequestChangeCallback,
  ) {
    super(
      `/api/parties/${partyId}/project/${projectId}/suppliers`,
      onRequestChanged,
    )
  }

  public async getSuppliers(
    workingStepTypeFilter: WorkingStepType[],
  ): Promise<ProjectSupplierDto[]> {
    return this.GetAsync<ProjectSupplierDto[]>({
      relativePath: '/',
      ...(workingStepTypeFilter && { params: { workingStepTypeFilter } }),
      id: 'getProjectSuppliers',
    })
  }
}
